import React from "react";
import "./footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-logos">
                <div className={'footer-unict-logo'}></div>
                <div className={'footer-samothrace-logo'}></div>
                <div className={'footer-alfameg-logo'}></div>
            </div>
        </footer>
    );
};

export default Footer;